//
// Copyright (c) 2025 Comcast
//

const en = {
  'translation': {
    'common': {
      'update': 'Update',
      'cancel': 'Cancel',
      'submit': 'Submit',
      'confirm': 'Confirm',
      'confirmChanges': 'Confirm Changes',
      'save': 'Save',
      'send': 'Send',
      'add': 'Add',
      'areYouSure': 'Are you sure?',
      'yes': 'Yes',
      'no': 'No',
      'copy': 'Copy',
      'close': 'Close',
      'enabled': 'enabled',
      'disabled': 'disabled',
      'notSelected': 'NOT SELECTED',
      'breadcrumbTicketingSystems': 'Ticketing Systems',
      'breadcrumbTicketingSystemsByPartner': '{{partnerName}} Ticketing Systems',
      'breadcrumbTicketingSystem': 'Ticketing System',
      'breadcrumbTicketEdit': 'Ticket Edit',
      'breadcrumbTicketClone': 'Ticket Clone',
      'breadcrumbTicketCreate': 'Ticket Create',
      'breadcrumbTicketRequests': 'Ticket Requests',
      'breadcrumbTicketsSearchResults': 'Search Results',
      'breadcrumbTicketProviders': 'Ticket Providers',
      'breadcrumbTicketProviderTicketBoards': 'Provider Ticket Boards',
      'breadcrumbPartners': 'Partners',
      'breadcrumbPartner': 'Partner',
      'breadcrumbOauthApps': 'Oauth Apps',
      'breadcrumbProviders': 'Providers',
      'breadcrumbSatClients': 'SAT Clients',
      'breadcrumbSatSecrets': 'SAT Secrets',
      'breadcrumbStatusCollections': 'Status Collections',
      'breadcrumbStatusCollection': 'Status Collection',
      'breadcrumbPartnerStatuses': 'Partner Statuses',
      'breadcrumbMimeTypeCollections': 'Mime Type Collections',
      'breadcrumbMimeTypeCollection': 'Mime Type Collection',
      'breadcrumbQueries': 'Queries',
      'breadcrumbMimeTypes': 'MIME Types',
      'breadcrumbSharedFieldsMaps': 'Shared Fields Maps',
      'breadcrumbColumns': 'Columns',
      'breadcrumbReleaseNotes': 'Release Notes',
      'breadcrumbReleaseNotesAdd': 'Add New Release',
      'breadcrumbReleaseNotesEdit': 'Edit {{releaseName}} Release',
      'breadcrumbUserProfile': 'User Profile',
      'breadcrumbProviderCredentials': 'Provider Credentials',
      'periodMin': 'min',
      'periodHour': 'h',
      'periodDay': 'day',
      'noChartData': 'no data',
      'noTableData': 'no data',
      'noTableDataWithFilterOrSearch': 'nothing found. try searching for something else or apply other filters',
      'success': 'success',
      'failed': 'failed',
      'uploadError': 'UPLOAD ERROR',
      'fileUploadtimeOut': 'File Upload Timed Out',
      'requestTimeOut': 'Request Timed Out',
      'multiSelectItemCount_one': 'and {{count}} other',
      'multiSelectItemCount_other': 'and {{count}} others',
      'inheritedFromProvider': 'INHERITED FROM PROVIDER',
      'typeHere': 'Type here',
      'requiredField': 'required field',
      'partner': 'partner',
      'email': 'email',
      'userName': 'user name',
      'description': 'description',
      'createdAt': 'created at',
      'updatedAt': 'updated at',
      'downloadCsv': 'Download CSV',
      'exportToCsv': 'Export to CSV',
      'moreLink': 'More',
      'tooltipCopy': 'Copy',
      'tooltipCopyLink': 'Copy Link',
      'tooltipCopied': 'Copied!',
      'tooltipShowMore': 'Show More',
      'tooltipDownload': 'Download',
      'lastReleaseNoteNotification': 'Relay {{version}} version was released. Please check release notes',
      'goToReleaseNotes': 'Go to Release Notes',
      'on': 'ON',
      'off': 'OFF',
      'confirmationInfoLine': 'Following changes will be submitted:',
      'sortedBy': 'Sorted by',
      'justificationInfoLine': 'Please add a justification for changing following fields:',
      'justificationInfoLineShort': 'Please add a justification for changing:',
      'viewSecureInfo': 'View Secure Info',
      'hideSecureInfo': 'Hide Secure Info',
      'sortTicketIdLabel': 'Ticket Id',
      'loading': 'Loading...',
    },
    'commonNotifications': {
      'timezoneChangeDetected': 'We\'ve detected you\'ve updated your time zone {{- timezone}}. Would you like to update your Relay time zone?',
      'timezoneChangeApproved': 'Your Relay time zone was automatically updated to {{- timezone}}',
      'updateProfile': 'Update Profile',
    },
    'commonTooltips': {
      'tooltipAudit': 'Open Audit',
      'exportConfig': 'Export Config',
      'settings': 'Settings',
    },
    'profilePage': {
      'firstName': 'First Name',
      'lastName': 'Last Name',
      'timeZone': 'Time Zone',
      'email': 'Email',
      'role': 'Role',
      'capability': 'Capability',
      'partner': 'Partner',
      'locale': 'Language',
      'autoSubscribe': 'Auto Subscribe to my tickets',
      'subscribeToNewReleases': 'Subscribe to Relay release notes ',
      'dashboard': 'Dashboard',
      'switcherText1': 'Create & track tickets',
      'switcherText2': 'Monitor integration',
      'switcherTooltip1': 'Submit and manage service management tickets',
      'switcherTooltip2': 'Access statistics, analyze errors and track overall bonding health',
      'avatarChange': 'change',
      'useTimeFormat24': 'Time format',
      'time24Hour': '24-hour time',
      'timezoneAutodetect': 'Automatically detect time zone',
      'myAccount': 'My Account',
      'myPreferences': 'My Preferences',
      'subscribeToNewTickets': 'Subscribe to new tickets',
      'mySubscriptions': 'My Subscriptions',
      'defaultImage': 'Default Image',
      'openFile': 'Open File',
    },
    'footer': {
      'releaseVersion': 'Release version',
      'hash': 'Hash',
      'deployedAt': 'Deployed at',
    },
    'header': {
      'lastUpdate': 'Last update',
    },
    'mainHeader': {
      'partners': 'Partners',
      'users': 'Users',
      'audit': 'Audit',
      'auditAll': 'All Partner Actions',
      'auditUsers': 'User Actions',
      'auditIntegration': 'Integration Actions',
      'auditAdmin': 'Admin Actions',
      'sentEmails': 'Sent Emails',
      'configuration': 'Configuration',
      'configTicketProviders': 'Ticket Providers',
      'configStatusCollections': 'Status Collections',
      'configMimeTypeCollections': 'Mime Type Collections',
      'configSharedMaps': 'Shared Fields Maps',
      'configMimeTypes': 'MIME Types',
      'configTicketingSystems': 'Ticketing Systems',
      'configQueries': 'Queries',
      'configProviderTicketBoards': 'Ticket Boards',
      'configSectionPartner': 'Partner',
      'configSectionEngine': 'Engine',
      'configSectionOtherSettings': 'Other Settings',
      'configSectionInternal': 'Internal',
      'configSectionAuthentication': 'Authentication',
      'featureFlags': 'Feature Flags',
      'requests': 'Requests',
      'requestsPartner': 'Partner Requests',
      'requestsInternal': 'Internal Communications',
      'requestsProxy': 'Proxy Communications',
      'reports': 'Reports',
      'reportsUsers': 'Users',
      'reportsUserFilters': 'User Filters',
      'reportsSubscriptions': 'Subscriptions',
      'reportsFeedback': 'Feedback',
      'partnersNewTicket': 'New ticket',
      'tickets': 'Tickets',
      'ticketsSectionPartner': 'Partner',
      'ticketsSectionProvider': 'Provider',
      'ticketsSectionProviders': 'Providers',
      'about': 'About',
      'aboutReleaseNotes': 'Release Notes',
      'aboutApiDocumentation': 'API Documentation',
      'userProfile': 'My Profile',
      'userSubscriptions': 'My Subscriptions',
      'userSatClients': 'SAT Management',
      'userSignOut': 'Sign Out',
      'userSignOutTitle': 'SIGN OUT',
      'userSignOutConfirm': 'Are you sure you want to sign out?',
      'filteredBy': 'Filtered by:',
      'searchPlaceholder': 'Search text in tickets...',
      'webhookEvents': 'Webhook Events',
      'asyncJobs': 'Async Jobs',
      'maintenanceTasks': 'Maintenance Tasks',
      'databasePerformance': 'Database Performance',
      'satClients': 'Sat Clients',
      'providerCredentials': 'Provider Credentials',
      'globalSearch': {
        'placeholder': 'Search text in tickets...',
        'noResults': 'no results',
        'exactMatch': 'EXACT MATCH',
        'suggested': 'SUGGESTED',
        'viewAllResults': 'View all results',
      },
    },
    'apiDocPage': {
      'pageTitle': 'API Documentation',
      'title': 'OpenApi Specification',
      'download': 'Download OpenApi Spec',
      'rebuildCache': 'Refresh API Doc Cache',
    },
    'dashboardPage': {
      'pageTitle': 'Dashboard',
      'greeting': 'Hello',
      'signedAs': 'You signed as',
      'summaryTab': 'Summary',
      'last24Hours': 'Last 24 hours',
      'last48Hours': 'Last 48 hours',
      'last7Days': 'Last 7 days',
      'last30Days': 'Last 30 days',
      'bonded': 'bonded',
      'unbonded': 'unbonded',
      'created': 'created',
      'closed': 'closed',
      'open': 'open',
      'activeTickets': 'active tickets',
      'activeUsers': 'active users',
      'withSubscriptions': 'with subscriptions',
      'moreLink': 'More',
      'bondedVsUnbondedTooltip': 'A widget shows count of all tickets\nby all time of bonded and unbonded ones',
      'bondedVsUnbonded': 'bonded vs. unbonded',
      'createdVsClosedTooltip': 'A widget shows count of all tickets\nwhich were created and closed by all time',
      'createdVsClosed': 'created vs. closed',
      'httpCodeRequestTooltip': 'A widget shows count of all requests\ngrouped by response code',
      'httpCodeRequest': 'http code requests',
      'recentTicketsTooltip': 'Latest created tickets',
      'recentTicketsHeader': 'recent tickets',
      'lastTicketSuccess': 'last ticket success',
      'lastTicketFail': 'last ticket fail',
      'lastCommentSuccess': 'last comment success',
      'lastCommentFail': 'last comment fail',
      'lastAttachmentSuccess': 'last attachment success',
      'lastAttachmentFail': 'last attachment fail',
      'action': 'action',
      'time': 'time at',
      'createAction': 'create',
      'updateAction': 'update',
      'collectionAction': 'collection',
      'recentApiRequestHeader': 'recent api requests',
      'latestRequestTooltipText': "Latest partner's requests to Relay API\nfor selected Ticketing system",
      'latestRequestStatusTooltipText': "Table shows date of last success requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets)",
      'latestFailRequestTooltipText': "Table shows date of last fail requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets)",
      'latestCommentSuccessTooltipText': 'Date of last success request to create comment',
      'latestCommentFailTooltipText': 'Date of last fail request to create comment',
      'latestAttachmentSuccessTooltipText': 'Date of last success request to create attachment',
      'latestAttachmentFailTooltipText': 'Date of last fail request to create attachment',
      'code': 'Code',
      'entity': 'Entity',
      'request': 'request',
      'msgResponse': 'msg response',
      'url': 'url',
      'executed': 'executed at',
      'activeSubscTooltip': 'List of latest emails which were sent to subscribers',
      'activeSubscHeader': 'active subscriptions triggered',
      'user': 'user',
      'status': 'status',
      'ticket': 'id',
      'createdClosedChart': 'created/closed tickets',
      'responseCodesChart': 'HTTP response codes',
      'adminRole': 'Admin',
      'role': 'Role',
      'adminRoRole': 'Admin Read-Only',
      'impersonate': 'Impersonate',
    },
    'ticketsPage': {
      'breadcrumbTicketingSystem': 'Ticketing System',
      'removeTicketsTitle': 'Remove Tickets',
      'removeTicketTitle': 'Remove Ticket',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}}',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}}',
      'statusesFilterPlaceholder': 'All Statuses',
      'searchPlaceholder': 'Search {{tsName}} tickets...',
      'searchPlaceholderNew': 'search tickets',
      'bulkRemoveLink': 'Bulk remove',
      'removeTicketsLink': 'Remove selected tickets',
      'reloadTicketsLink': 'Reload tickets',
      'status': 'Status',
      'ticket': 'Ticket',
      'ticketsFound': '{{ticketsCount}} tickets found by:',
      'ticketsCount_one': '{{count}} ticket',
      'ticketsCount_other': '{{count}} tickets',
      'sortedByPlaceholder': 'Choose Sorting Field',
      'resetSortingTooltip': 'Reset to Default',
      'sortDirectionTooltip': 'Reverse Sort Direction',
      'sortRelayTicketIdLabel': 'Relay Ticket Id',
      'clearFiltersLink': 'Clear All Filters',
      'tableHeaderId': 'Ticket ID',
      'tableHeaderTitle': 'Title',
      'tooltipMultiUserFilter': 'Multi-user filter',
      'tooltipAdminOnlyFilter': 'Admin-only filter',
      'tooltipPrivateFilter': 'Private filter',
      'filters': 'Filters',
      'removeFilterTitle': 'Remove Filter',
      'removeFilterMessage': 'Are you sure you want to remove \'{{ filterName }}\' filter?',
      'subscribeToNewTickets': 'Subscribe to new tickets',
      'unSubscribeToNewTickets': 'Unsubscribe from new tickets',
      'subscribeToTicketsView': 'Subscribe to receive notifications about new tickets',
      'unSubscribeToTicketsView': 'Unsubscribe from tickets view',
      'subscribeToTicketsViewTitle': 'Subscribe to Tickets View',
      'subscribeToTicketsViewName': 'View Name',
      'subscribeToTicketsViewFilters': 'Filters',
      'subscribeToTicketsViewStatuses': 'Statuses',
      'subscribeToTicketsViewSearch': 'Search',
      'subscribeToTicketsViewAllTickets': 'All Tickets',
      'subscribeToTicketsViewGroupName': 'Tickets View',
      'manageSubscriptions': 'Manage Subscriptions',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children',
      'tooltipChildTicketsMore': ' and {{count}} more',
      'attachmentsCount_one': '{{count}} attachment',
      'attachmentsCount_other': '{{count}} attachments',
      'commentsCount_one': '{{count}} comment',
      'commentsCount_other': '{{count}} comments',
      'emptyFiltersText': 'No active filters available',
      'createFilterTooltip': 'Create Filter',
      'editFilterTooltip': 'Edit Filter',
      'removeFilterTooltip': 'Remove Filter',
      'filterPanelTitle': 'Tickets View',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar',
      'filterPanelFiltersTooltip': 'Active Custom Filters',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters',
      'filterPanelSearchTooltip': 'Click to Search',
      'filterPanelClearSortingTooltip': 'Clear Sorting',
      'filtersStatusSectionTitle': 'Statuses',
      'filterForm': {
        'title': 'Filter Settings',
        'generalInformation': 'General Information',
        'conditions': 'Conditions',
        'saveFilter': 'Save Filter',
        'deleteFilter': 'Delete Filter',
        'fieldLabelName': 'Name',
        'fieldLabelVisibility': 'Visibility',
        'visibilityPrivate': 'Private',
        'visibilityAdmins': 'Admins',
        'visibilityAllUsers': 'All Users',
        'providerTicketBoards': 'Ticket Boards',
        'providerTicketBoardsPlaceholder': 'Ticket Boards Visibility',
        'advancedMode': 'Advanced mode',
        'addNewCondition': 'Add New Condition',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3',
        'resultExpression': 'Result Expression',
        'resultExpressionText': 'Show when {{- query}}',
        'table': {
          'field': 'field',
          'operator': 'operator',
          'value': 'value',
        },
        'allFieldsLabel': 'Ticket Fields',
        'dynamicFieldsLabel': 'Dynamic Options',
        'selectFieldPlaceholder': 'select field',
        'selectOperatorPlaceholder': 'select operator',
        'selectValuePlaceholder': 'select value',
        'optionLabels': {
          'is_me': 'Is Me',
          'my_company': 'My Company',
        },
        'removeConditionTooltip': 'Remove Condition',
      },
    },
    'ticketFilterForm': {
      'updateFilter': 'Update Filter',
      'createNewFilter': 'Create New Filter',
      'validateMsgNameRequired': 'Name is required',
      'validateMsgNameExists': 'This name already exists',
      'validateMsgQueryReuired': 'Query is required',
      'validateMsgConditionsRequired': 'Conditions are required',
      'validateMsgConditionsEmpty': 'Condition value should not be empty',
      'conditionsTip':
        'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
        'Keywords: AND, OR\n\n' +
        'Example:\n' +
        'title LIKE "test" OR severity IN 5,4,3',
      'name': 'NAME',
      'namePlaceholder': 'Filter name...',
      'conditions': 'CONDITIONS',
      'advanced': 'Advanced',
      'multiUser': 'Multi-user enabled',
      'showWhenCondition': 'Show when {{- condition}}',
      'addQuery': 'Add Query Language Code',
      'queryPlaceholder': 'Type the query',
      'saveFilter': 'Save Filter',
      'allFieldsLabel': 'Ticket Fields',
      'dynamicFieldsLabel': 'Dynamic Options',
      'isMe': 'Is Me',
      'myCompany': 'My Company',
    },
    'ticketPage': {
      'tableNoData': 'no data',
      'cloneTicketLink': 'Clone ticket',
      'createTicketLink': 'Create ticket',
      'deleteTicketLink': 'Remove ticket',
      'editModeLink': 'Edit Details',
      'refetchTicketLink': 'Reload ticket',
      'requestTicketLink': 'Show ticket requests',
      'addChildTicketsLink': 'Add tickets',
      'moveTicketLink': 'Move ticket',
      'removeTicketTitle': 'Remove Ticket',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}}',
      'webhookTicketLink': 'Show webhook events',
      'unsubscribeLink': 'Unsubscribe',
      'subscribeLink': 'Subscribe',
      'subscribeLinkHint': 'You are not able to subscribe, <1>please update your email!</1>',
      'commentsAll': 'All',
      'commentsOnly': 'only',
      'comments': 'Comments',
      'commentNew': 'New Comment',
      'commentsNo': 'No comments',
      'commentsValidateBody': 'Comment body is required',
      'commentAbsoluteDate': '{{author}} commented at {{date}}',
      'commentedAt': 'commented at {{date}}',
      'attachments': 'Attachments',
      'attachmentAdd': 'Add Attachment',
      'attachmentTooBig': 'Attachment file is too big',
      'attachmentInvalidType': 'Attachment file is invalid: {{extension}} ({{contentType}})',
      'attachmentsNo': 'No attachments',
      'attachmentsHeaderId': 'ID',
      'attachmentsHeaderFilename': 'Filename',
      'attachmentsHeaderOwner': 'Owner',
      'attachmentsHeaderCreated': 'Created',
      'attachmentsHeaderSize': 'Size',
      'sidebarDetails': 'DETAILS',
      'sidebarSectionTicketingSystem': 'TICKETING SYSTEM',
      'sidebarSectionTicketId': 'Ticket ID',
      'sidebarSectionRelayId': 'Relay Ticket ID',
      'sidebarSectionType': 'Type',
      'sidebarSectionChildren': {
        'title': 'Children',
        'columns': {
          'id': 'Ticket ID',
          'title': 'Title',
        },
      },
      'sidebarSectionParent': 'Parent',
      'hideReadOnlyFields': 'Hide Read-Only Fields',
      'filteredBy': 'Filtered By',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners',
        'extensionsFilterPlaceholder': 'All Types',
        'searchPlaceholder': 'search attachments',
        'filterPanelSearchTooltip': 'Click to Search',
        'filterPanelClearSortingTooltip': 'Clear Sorting',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE',
          'type': 'TYPE',
          'size': 'SIZE',
          'filename': 'FILE NAME',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners',
        'authorsFilterPlaceholder': 'All Authors',
        'searchPlaceholder': 'search comments',
        'filterPanelSearchTooltip': 'Click to Search',
        'filterPanelClearSortingTooltip': 'Clear Sorting',
        'sortFieldLabel': 'CREATED DATE',
      },
      'childrenSection': {
        'title': 'Children',
      },
      'addTicketsForm': {
        'title': 'Add Tickets',
        'ticketList': 'Ticket List',
        'placeholder': 'Enter ticket ID or title',
      },
      'moveTicketForm': {
        'title': 'Move Ticket',
        'parentTicket': 'Parent',
        'placeholder': 'Enter ticket ID or title',
      },
    },
    'dropzoneFileInput': {
      'placeholder': 'Open or drop file here',
      'maxSizeInfo': 'Max upload size: {{maxSizeText}}',
    },
    'fileProgressbar': {
      'progressText': '{{currentBytesText}} of {{totalBytesText}}',
    },
    'exportFileProgressBar': {
      'progressText': '{{currentPercent}}% of CSV file generated',
    },
    'sidebar': {
      'title': 'Details',
      'statusSection': 'STATUS',
      'userSection': 'CREATED BY USER',
      'noData': 'no data',
      'sidebarSectionsBySchema': {
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map',
        'sectionMimeTypeCollectionLinkTooltip': 'Open Mime Type Collection',
        'sectionTicketProviderLinkTooltip': 'Open Ticket Provider',
        'sectionProviderCredentialLinkTooltip': 'Open Provider Credential',
      },
    },
    'ticketEditPage': {
      'pageHeader': 'Edit {{ticketName}} in {{tsName}}',
      'fields': 'Fields',
    },
    'ticketClonePage': {
      'pageHeader': 'Clone Ticket in {{tsName}}',
    },
    'ticketCreatePage': {
      'pageHeader': 'Create Ticket in {{tsName}}',
    },
    'ticketRequestsPage': {
      'pageHeader': 'Requests for {{ticketName}} in {{tsName}}',
    },
    'ticketForm': {
      'buttonCloneTicket': 'Clone Ticket',
      'buttonCreateTicket': 'Create Ticket',
      'inheritedFromParent': 'Inherited from parent',
    },
    'tableFormFieldsBuilder': {
      'creatableArrayField': {
        'text': 'or add via CSV/XLS file',
        'tooltip': 'Open CSV/XLS file',
        'optionsEmpty': 'Empty',
        'optionsAdd': 'Add',
        'itemsMax_one': 'maximum {{count}} item',
        'itemsMax_other': 'maximum {{count}} items',
        'itemsLeft_one': '{{count}} item left',
        'itemsLeft_other': '{{count}} items left',
        'itemsOver_one': '{{count}} item over',
        'itemsOver_other': '{{count}} items over',
        'placeholderAddItems': 'Add items...',
      },
      'editableArrayField': {
        'tooltipAdd': 'Add New Item',
        'tooltipRemove': 'Remove Item',
        'addButtonLabel': 'Add Item',
      },
    },
    'appRequestsPage': {
      'header': 'Requests',
      'tableHeaderRequest': 'Request',
      'tableHeaderPartner': 'Partner',
      'tableHeaderOrigin': 'Origin',
      'tableHeaderMethod': 'Method',
      'tableHeaderExecutedAt': 'Executed At',
      'tableHeaderCode': 'Code',
      'tableHeaderResponseTime': 'Response Time',
      'sidebarDetails': 'REQUEST DETAILS',
      'sidebarSectionRequestId': 'Request ID',
      'sidebarSectionCorrelationId': 'Correlation ID',
      'sidebarSectionTicketIds': 'Ticket IDs',
      'sidebarSectionTicketProvider': 'Ticket Provider',
      'sidebarSectionTicketProviderId': 'Id',
      'sidebarSectionTicketProviderName': 'Name',
      'sidebarSectionTs': 'Ticketing System',
      'sidebarSectionTsId': 'ID',
      'sidebarSectionTsName': 'Name',
      'sidebarSectionUrl': 'URL',
      'sidebarSectionRespondedAt': 'Responded at',
      'sidebarSectionRespPayload': 'Response Payload',
      'sidebarSectionAuthToken': 'Auth Token',
      'sidebarSectionReqPayload': 'Request Payload',
      'sidebarSectionReqPayloadSize': 'Request Payload Size',
      'sidebarSectionServerName': 'Server Name',
      'sidebarSectionReleaseVersion': 'Release Version',
      'sidebarSectionSourceIp': 'Source IP',
      'sidebarSectionClientId': 'Client ID',
      'sidebarSectionExternalRequestId': 'External Request ID',
      'sidebarSectionWebhookEventId': 'Webhook Event ID',
      'sidebarSectionWebhookExternalEventId': 'Webhook External Event ID',
      'filtersSidebarTitle': 'Filters',
      'clearFiltersLink': 'Clear All Filters',
      'requestsFound_one': '{{count}} request found',
      'requestsFound_other': '{{count}} requests found',
      'traceTooltip': 'Find telemetry trace',
      'copyTooltip': 'Copy Request Details',
    },
    'searchBy': {
      'title': 'Search by',
      'placeholder': 'search',
    },
    'subscriptionsPage': {
      'header': 'Subscriptions',
      'tableHeaderId': 'Ticket ID',
      'tableHeaderStatus': 'Status',
      'tableHeaderTitle': 'Title',
      'tableHeaderUpdated': 'Ticket Updated',
      'inactiveTooltip': 'Ticketing System for this ticket is inactive',
      'unsubscribeTooltip': 'Unsubscribe',
      'subscriptionTypeTickets': 'Tickets',
      'subscriptionTypeViews': 'Views',
      'subscriptionName': 'Name',
      'subscriptionCreatedAt': 'Created At',
      'subscriptionFilteredBy': 'Filtered by',
      'subscriptionsFound': '{{subscriptionsCount}} subscriptions found by:',
      'filterTsLabel': 'All Ticketing Systems',
      'subscribeToAllTickets': 'All Tickets',
      'subscribeToStatus': 'Statuses',
      'subscribeToFilter': 'Filters',
      'subscribeToSearch': 'Search',
      'clearFiltersLink': 'Clear All Filters',
      'filterPanelClearSortingTooltip': 'Clear Sorting',
      'subscriptionGoToViews': 'Open Tickets View',
      'FiltersText': 'Filters',
      'SearchText': 'Search',
      'providerTicketBoardText': 'Board',
      'subscriptionsCount_one': '{{count}} subscription',
      'subscriptionsCount_other': '{{count}} subscriptions',
    },
    'releaseNotesPage': {
      'header': 'Release Notes',
      'headerAdd': 'Add New Release',
      'headerEdit': 'Edit {{releaseName}} Release',
      'addRelease': 'Add New Release',
      'subscribeRelease': 'Subscribe to Release Notes',
      'unsubscribeRelease': 'Unsubscribe from Release Notes',
      'editRelease': 'Edit Release',
      'sidebarHeader': 'Releases Archive',
      'publishedTooltip': 'Published Release',
      'unpublishedTooltip': 'Unpublished Release',
      'publishedBadge': 'published',
      'unpublishedBadge': 'unpublished',
      'releaseEmpty': 'Release Notes list is empty',
      'removeReleaseTitle': 'Remove Release Note',
      'removeReleaseMessage': 'Are you sure you want to remove the release note?',
      'editConfirmTitle': 'Save Changes?',
      'editConfirmMessage': 'Please confirm your changes.',
      'formUpdateRelease': 'Update Release',
      'formRemoveRelease': 'Remove Release',
      'formVersion': 'VERSION',
      'formVersionPlaceholder': 'type here',
      'formDate': 'DATE',
      'formDatePlaceholder': 'please select date & time',
      'formPublished': 'PUBLISHED',
      'formDescription': 'DESCRIPTION',
      'formDescriptionPlaceholder': 'add description',
      'formDescriptionTooltip':
        'Please use next format for release notes:\n\n' +
        '## Title Text\n' +
        '### Section 1\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '### Section 2\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '...\n' +
        '### Section N\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '## Footer Text',
    },
    'datetimeInput': {
      'placeholderDate': 'Please select Date',
      'placeholderDateTime': 'Please select Date & Time',
      'timeLabel': 'TIME',
      'am': 'am',
      'pm': 'pm',
      'hours': 'HOURS',
      'minutes': 'MINUTES',
      'seconds': 'SECONDS',
    },
    'sentEmailsPage': {
      'title': 'Sent Emails',
      'filterPanelTitle': 'Filters',
      'filterPanelTitleTooltip': 'Click to open filters sidebar',
      'clearFilterTooltip': 'Clear {{filterName}} filter',
      'clearAllFiltersTooltip': 'Clear all filters',
      'filterPanelFiltersTooltip': 'Active filters',
      'emailsCount': '{{count}} emails',
      'filters': {
        'recipient': 'Recipient',
        'ticketNumber': 'Ticket Number',
        'subject': 'Subject',
        'partner': 'Partner',
        'partners': 'Partners',
        'ticketProvider': 'Ticket Provider',
        'actionType': 'Action Type',
        'code': 'Code',
        'codes': 'Codes',
        'state': 'State',
        'status': 'Status',
      },
      'table': {
        'headerPartner': 'Partner',
        'headerSmtpCode': 'SMTP Code',
        'headerSubject': 'Subject',
        'headerRecipient': 'Recipient',
        'headerSentAt': 'Sent at',
        'actionResendToMe': 'Resend to Me',
        'actionResendToMeError': 'Resend to Me (Fail)',
        'headerType': 'Action Type',
      },
      'rightSideBar': {
        'title': 'EMAIL DETAILS',
        'sectionSubject': 'Subject',
        'sectionRecipient': 'Recipient',
        'sectionSmtpRespMsg': 'SMTP Response Message',
        'sectionTicketNumber': 'Ticket number',
        'sectionTicketingSystem': 'Ticketing System',
        'sectionState': 'State',
      },
    },
    'columnsPage': {
      'pageHeader': 'Manage Columns for',
      'addColumn': 'Add Column',
      'addNewColumn': 'Add New Column',
      'formFieldName': 'Partner Name',
      'formFieldColId': 'External Name',
      'removeColumn': 'Remove Column',
      'removeColumnMessage': 'Are you sure you want to remove \'{{ columnName }}\' column?',
      'restoreSharedColumn': 'Restore Shared Column',
      'restoreSharedColumnMessage': 'Are you sure you want to restore \'{{ columnName }}\' shared column?',
      'restoreTooltip': 'Restore Shared',
      'removeTooltip': 'Remove',
      'sharedTooltip': 'Shared',
      'customizedTooltip': 'Customized',
      'compareTooltip': 'Compare field map',
      'loadingMatches': 'Loading...',
      'noMatches': 'No matches',
      'tableHeaderPartnerColumnName': 'partner column name',
      'tableHeaderExternalColumnName': 'external column name',
      'tableHeaderVisible': 'visible',
      'tableHeaderFormVisible': 'visible in form',
      'tableHeaderViewVisible': 'visible in view',
      'tableHeaderFormCreatable': 'creatable',
      'tableHeaderPreview': 'preview',
      'tableHeaderCloned': 'cloned',
      'tableHeaderCloneable': 'cloneable',
      'tableHeaderRequired': 'required',
      'tableHeaderFilterable': 'filterable',
      'tableHeaderFieldType': 'field type',
      'tableHeaderCommentRequired': 'Comment Required',
      'columnNamePlaceholder': 'Please enter column name',
      'columnExternalColumnIdPlaceholder': 'Please enter external name',
      'rightSideBar': {
        'formConfig': 'Form Config',
        'viewConfig': 'View Config',
        'formConfigTooltip': 'Configure columns on Ticket Create/Edit/Clone pages',
        'viewConfigTooltip': 'Configure columns on Ticket/Tickets View pages',
        'localizedFieldsOnly': 'Localizations fields only',
        'partnerColumnName': 'Partner Column Name',
        'externalColumnName': 'External Column Name',
        'defineAllowed': 'Define Allowed',
        'defineValueMapping': 'Define Value Mapping',
        'defineExternalToPartnerMapping': 'Enable external value mapping',
        'definePartnerToExternalMapping': 'Enable partner value mapping',
        'defineTableTypeConfig': 'Table configuration',
        'tableTypeConfigIsEmpty': 'Table is empty',
        'addTableTypeConfigItem': 'Add column',
        'editTableTypeConfigItem': 'Edit column',
        'partnerValue': 'partner value',
        'externalValue': 'external value',
        'allowed': 'Allowed',
        'allowedIsEmpty': 'Allowed list is empty',
        'name': 'Name',
        'namePlaceholder': 'Please enter name',
        'value': 'Value',
        'valuePlaceholder': 'Please enter value',
        'default': 'default',
        'tooltip': 'tooltip',
        'placeholder': 'placeholder',
        'visible': 'visible',
        'writeable': 'writeable',
        'creatable': 'creatable',
        'editable': 'editable',
        'setOnce': 'set once',
        'displayInSidebar': 'display in sidebar',
        'showInPreview': 'show in preview',
        'displayInPreview': 'display in preview',
        'cloned': 'cloned',
        'cloneable': 'cloneable',
        'filterable': 'filterable',
        'sortable': 'sortable',
        'hideValueInEmail': 'Hide value in Email',
        'notifyViaEmail': 'Notify via Email',
        'field_type': 'Field Type',
        'main_ui_attr': 'Main UI Attribute',
        'main_external_attr': 'Main External Attribute',
        'nested_field_name': 'Nested Field Name',
        'required': 'required',
        'commentRequired': 'comment required',
        'tooltipRequired': 'Field can be required if it has default value or it is visible and writeable',
        'tooltipShowInPreview': 'Show this field in the preview section on the Tickets List page',
        'tooltipDisplayInSidebar': 'Show this field in the sidebar section on the Ticket View page',
        'tooltipDisplayInSidebarFormConfig': 'Show this field in the sidebar section on the Ticket Create/Edit/Clone pages',
        'manageAllowed': 'MANAGE FIELD MAPPING',
        'modalHeader': 'Discard Changes',
        'modalText': 'Are you sure you want to discard changes?',
        'modalHeaderRemove': 'Remove {{columnName}}',
        'modalTextRemove': 'Are you sure you want to remove \'{{valueName}}\' {{columnName}}?',
        'tooltipEdit': 'Edit',
        'tooltipRemove': 'Remove',
        'addAllowed': 'Add Allowed Value',
        'editAllowed': 'Edit Allowed Value',
        'changeOrder': 'Change Order',
        'addExternalValueMapping': 'Add New External Value Map',
        'editExternalValueMapping': 'Edit External Value Map',
        'externalValueMappingIsEmpty': 'External value mapping is empty',
        'removeExternalMappingValue': 'Remove External Value Map',
        'removeExternalMappingValueText': 'Are you sure you want to remove \'{{ externalValue }}\' external value map?',
        'addPartnerValueMapping': 'Add New Partner Value Map',
        'editPartnerValueMapping': 'Edit Partner Value Map',
        'partnerValueMappingIsEmpty': 'Partner value mapping is empty',
        'removePartnerMappingValue': 'Remove Partner Value Map',
        'removePartnerMappingValueText': 'Are you sure you want to remove \'{{ partnerValue }}\' partner value map?',
        'externalValueForm': {
          'value': 'value',
          'valuePlaceholder': 'input value',
        },
        'emptyPartnerValue': 'empty',
        'partnerValueForm': {
          'value': 'value',
          'valuePlaceholder': 'input value',
          'default': 'default',
        },
        'arrayCsvLimit': 'Limit of max number of items',
      },
      'settingsModal': {
        'title': 'Column Settings',
      },
    },
    'select': {
      'noOptions': 'no data',
      'placeholder': 'Select...',
      'loadingMessage': 'loading...',
    },
    'partnersPage': {
      'pageHeader': 'Partners',
      'addPartner': 'Add Partner',
      'addNewPartner': 'Add New Partner',
      'formFieldName': 'Name',
      'partnerNamePlaceholder': 'Please enter partner name',
      'formFieldXerxesPartnerName': 'Xerxes Name',
      'formFieldXerxesPartnerNamePlaceholder': 'Please enter Xerxes partner name',
      'fieldSsoZone': 'SSO Zone',
      'fieldSsoEnv': 'SSO Environment',
      'ssoZonePlaceholder': 'Please select SSO Zone',
      'ssoEnvPlaceholder': 'Please select SSO Environment',
      'fieldXerxesZone': 'Xerxes Zone',
      'fieldXerxesEnv': 'Xerxes Environment',
      'xerxesZonePlaceholder': 'Please select Xerxes Zone',
      'xerxesEnvPlaceholder': 'Please select Xerxes Environment',
      'formFieldSatPartnerName': 'SAT Name',
      'formFieldSatPartnerNamePlaceholder': 'Please enter SAT partner name',
      'fieldSatZone': 'SAT Zone',
      'satZonePlaceholder': 'Please select SAT Zone',
      'fieldSatEnv': 'SAT Environment',
      'satEnvPlaceholder': 'Please select SAT Environment',
      'removePartnerTitle': 'Remove Partner',
      'removePartnerMessage': 'Are you sure you want to remove \'{{partnerName}}\' partner?',
      'tableHeaderPartnerName': 'partner name',
      'tableHeaderMainPartner': 'main partner',
      'tableHeaderActive': 'active',
      'tableHeaderVisibility': 'visibility',
      'visibilityFull': 'full',
      'visibilityRestricted': 'restricted',
      'tooltipOauthApps': 'Manage Oauth apps',
      'tooltipGenerateOpenApi': 'Generate OpenApi',
      'tooltipTicketingSystems': 'Ticketing Systems',
      'tooltipRemovePartner': 'Remove Partner',
      'rightSideBar': {
        'sectionPartnerName': 'Partner Name',
        'sectionXerxesPartnerName': 'Xerxes Partner Name',
        'sectionActive': 'Active',
        'sectionMainPartner': 'Main Partner',
        'sectionUseMtls': 'Use MTLS authentication',
        'sectionVisibility': 'Visibility',
        'sectionLogo': 'Logo',
        'sectionSystemBranding': {
          'title': 'System Branding',
          'copyrightText': 'Copyright Text',
          'logo': 'Logo',
        },
        'sectionLandingPage': {
          'header': 'Landing Page Content',
          'title': 'Title',
          'titlePlaceholder': 'Please, enter title',
          'text': 'Text',
          'textPlaceholder': 'Please, enter text',
        },
        'sectionManage': 'Manage',
        'visibilityFull': 'Full',
        'visibilityRestricted': 'Restricted',
        'sectionTicketIdName': 'Ticket id field name',
      },
      'settingsModal': {
        'title': 'Partner Settings',
      },
    },
    'iconRecommendation': {
      'recommendations': 'Recommendations',
      'size': 'size',
      'formats': 'formats',
      'uploadLogo': 'Upload Logo',
    },
    'imagePicker': {
      'recommendationsTitle': 'Recommendations',
      'size': 'size',
      'formats': 'formats',
      'uploadLogo': 'Upload Logo',
      'updateLogo': 'Update Logo',
    },
    'statusCollectionsPage': {
      'pageHeader': 'Status Collections',
      'addEntity': 'Add Status Collection',
      'importStatusCollection': 'Import Status Collection',
      'addNewEntity': 'Add New Status Collection',
      'formFieldName': 'Name',
      'statusCollectionNamePlaceholder': 'Please enter Status Collection name',
      'removeStatusCollectionTitle': 'Remove Status Collection',
      'removeStatusCollectionMessage': 'Are you sure you want to remove \'{{statusCollectionName}}\' status collection?',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems or ticket providers',
      'hintCannotBeRemovedHasStatuses': 'Cannot be removed while it has partner statuses',
      'manageStatuses': 'Manage Partner Statuses',
      'tableHeaderName': 'Status Collection Name',
      'rightSideBar': {
        'title': 'DETAILS',
        'sectionUsedBy': 'Used By',
        'sectionUsedByTicketingSystem': 'Ticketing Systems',
        'sectionUsedByTicketProvider': 'Ticket Providers',
      },
      'settingsModal': {
        'title': 'Status Collection Settings',
      },
    },
    'statusCollectionPage': {
      'pageHeader': 'Partner Statuses for',
      'addEntity': 'Add Partner Status',
      'addNewEntity': 'Add new partner status',
      'tableHeaderPartnerStatus': 'Partner Status',
      'tableHeaderExternalStatuses': 'External Statuses',
      'tableHeaderDefault': 'Default',
      'removePartnerStatusTitle': 'Remove partner status',
      'removePartnerStatusMessage': 'Are you sure you want to remove \'{{ partnerStatusName }}\' partner status?',
      'tooltipRemove': 'Remove',
      'partnerStatusName': 'Name',
      'partnerStatusClosedState': 'Closed State',
      'partnerStatusNamePlaceholder': 'Please enter partner status name',
      'partnerStatusColor': 'Status Color',
      'partnerStatusDefault': 'Default',
      'extFormName': 'Name',
      'extFormNamePlaceholder': 'Please enter name for external status',
      'extFormNotes': 'Notes',
      'extFormNotesPlaceholder': 'Please enter notes for external status',
      'extFormStatusTrans': 'Status Transitions',
      'extFormReadOnly': 'Read Only',
      'manageExternalStatuses': 'Manage External Statuses',
      'externalStatusesTab': 'External Statuses',
      'rightSideBar': {
        'title': 'DETAILS',
      },
      'settingsModal': {
        'title': 'Partner Status Settings',
      },
    },
    'externalStatusesPage': {
      'pageHeader': 'External Statuses for',
      'addEntity': 'Add External Status',
      'addNewEntity': 'Add New External Status',
      'breadcrumbExternalStatuses': 'External Statuses',
      'tableHeaderName': 'Name',
      'tableHeaderNote': 'Note',
      'tableHeaderTransitions': 'Transitions',
      'tableHeaderReadOnly': 'Read Only',
      'removeExternalStatusTitle': 'Remove external status',
      'removeExternalStatusMessage': 'Are you sure you want to remove \'{{ externalStatusName }}\' external status?',
      'tooltipRemove': 'Remove',
      'rightSideBar': {
        'title': 'DETAILS',
      },
      'settingsModal': {
        'title': 'External Status Settings',
      },
    },
    'ticketProvidersPage': {
      'importTicketProvider': 'Import Ticket Provider',
      'pageHeader': 'Ticket Providers',
      'addProvider': 'Add Provider',
      'addNewProvider': 'Add New Ticket Provider',
      'formFieldName': 'Name',
      'formFieldProjectName': 'Project Name',
      'formPlaceholderName': 'Enter Name',
      'formPlaceholderProjectName': 'Enter Project Name',
      'removeProviderTitle': 'Remove Ticket Provider',
      'removeProviderMessage': 'Are you sure you want to remove \'{{ticketProviderName}}\' ticket provider?',
      'cleanupTickets': 'Cleanup tickets',
      'cleanupTicketsMessage': 'Are you sure you want to remove all tickets for selected ticket provider?',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems',
      'tableHeaderProviderName': 'ticket provider name',
      'tableHeaderProviderType': 'type',
      'tableHeaderProjectName': 'project name',
      'tableHeaderTsCount': 'ticketing systems count',
      'tableHeaderEndpoint': 'endpoint',
      'tableHeaderStatusCollection': 'status collection',
      'tableHeaderSharedMap': 'shared fields map',
      'showQueriesTooltip': 'Show Queries',
      'showProviderTicketBoardsTooltip': 'Show Ticket Boards',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name',
        'sectionProjectName': 'Project Name',
        'sectionTCEndpoint': 'Endpoint',
        'sectionTPType': 'Type',
        'sectionUrl': 'URL',
        'sectionClientId': 'Client Id',
        'sectionUsername': 'User Name',
        'sectionConnection': 'Connection',
        'sectionAttachments': 'Attachments',
        'sectionComments': 'Comments',
        'sectionCloneTickets': 'Clone tickets',
        'sectionAllowNewTickets': 'Create tickets',
        'sectionStatusCollection': 'Status Collection',
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection',
        'sectionSharedMap': 'Shared Fields Map',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map',
        'sectionUsedBy': 'Used By',
        'sectionUsedByTicketingSystem': 'Ticketing Systems',
        'sectionLogo': 'Logo',
        'sectionKinesisEnabled': 'Kinesis',
        'sectionStreamName': 'Stream Name',
        'sectionRegion': 'Region',
        'sectionRole': 'Role',
      },
      'connectionSettingsModal': {
        'title': 'Connection',
        'providerType': 'Provider Type',
        'settings': 'Settings',
      },
      'settingsModal': {
        'title': '{{name}} Provider Settings',
      },
    },
    'queriesPage': {
      'enqueueQuery': 'Perform Query',
      'dryRunQuery': 'Dry Run Query',
      'dryRunEmptyResult': 'Result is empty',
      'dryRunQueryModalTitle': '\'{{queryName}}\' Query Dry Run Result',
      'newPageHeader': 'Manage Queries',
      'breadcrumbs': 'Queries',
      'pageHeader': 'Queries for {{ type }}',
      'addQuery': 'Add Query',
      'addFormTitle': 'Add New Query',
      'addFormQueryName': 'NAME',
      'addFormQueryNamePlaceholder': 'name',
      'addFormQueryBody': 'BODY',
      'addFormQueryBodyPlaceholder': 'description',
      'removeQueryTitle': 'Remove Query',
      'removeQueryMessage': 'Are you sure you want to remove \'{{queryName}}\' query?',
      'tableHeaderQueryName': 'query name',
      'tableHeaderActive': 'active',
      'tableHeaderExecPeriod': 'execution period',
      'useToReloadTickets': 'Use to Reload Tickets',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name',
        'sectionQueryName': 'Name',
        'sectionQueryBody': 'Body',
        'sectionStartAt': 'Start At',
        'sectionMaxResults': 'Max Results',
        'sectionExecPeriod': 'Execution Period',
        'sectionTicketProvider': 'Ticket Provider',
        'sectionActive': 'Active',
        'offsetTooltipText': 'Time Offset in Minutes',
      },
      'settingsModal': {
        'title': 'Query Settings',
      },
    },
    'providerTicketBoardsPage': {
      'newPageHeader': 'Manage Ticket Boards',
      'breadcrumbs': 'Ticket Boards',
      'addTicketBoard': 'Add Ticket Board',
      'addFormTitle': 'Add New Ticket Board',
      'addFormTicketBoardName': 'NAME',
      'addFormTicketBoardNamePlaceholder': 'name',
      'addFormTicketBoardQuery': 'QUERY',
      'addFormTicketBoardQueryPlaceholder': 'Query body',
      'removeTicketBoardTitle': 'Remove Ticket Board',
      'removeTicketBoardMessage': 'Are you sure you want to remove \'{{providerTicketBoardName}}\' ticket board?',
      'tableHeaderTicketBoardName': 'Ticket Board Name',
      'tableHeaderActive': 'active',
      'tableHeaderDefault': 'default',
      'tooltipEditTable': 'Edit Table',
      'tooltipEditCsvExportTable': 'Edit CSV Export Table',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name',
        'sectionTicketBoardName': 'Name',
        'sectionTicketBoardQuery': 'Query',
        'sectionActive': 'Active',
        'sectionDefault': 'Default',
        'sectionUsedBy': 'Used By',
      },
      'settingsModal': {
        'title': 'Ticket Board Settings',
      },
    },
    'csvExportTableEditPage': {
      'pageHeader': 'Edit Ticket CSV Export Table',
    },
    'sharedFieldsMapsPage': {
      'pageHeader': 'Shared Fields Maps',
      'importSharedFieldsMap': 'Import Shared Fields Map',
      'addEntity': 'Add Shared Fields Map',
      'addNewEntity': 'Add New Shared Fields Map',
      'formFieldName': 'Name',
      'sharedFieldsMapNamePlaceholder': 'Please enter Shared Fields Map name',
      'removeEntity': 'Remove Shared Fields Map',
      'removeEntityMessage': 'Are you sure you want to remove \'{{sharedFieldsMapName}}\' shared fields map?',
      'manageColumns': 'Manage Columns',
      'tableHeaderName': 'shared fields map name',
      'rightSideBar': {
        'title': 'DETAILS',
        'sectionSharedFieldsMapName': 'Shared Fields Map Name',
        'sectionUsedBy': 'Used By',
        'sectionUsedByTicketProvider': 'Ticket Provider',
      },
      'settingsModal': {
        'title': 'Shared Fields Maps Settings',
        'sectionUsedByTicketProvider': 'Ticket Providers',
      },
    },
    'auditPage': {
      'actionsTitle': 'ACTIONS',
      'actionCreate': 'Create action',
      'actionUpdate': 'Update action',
      'actionDestroy': 'Destroy action',
      'tableHeader': 'Action',
      'justificationTitle': 'Justification',
      'sideBarTitle': 'CHANGES',
      'actionsType': {
        'allPartnerActions': 'all_partner_actions',
        'userActions': 'user_actions',
        'integrationActions': 'integration_actions',
        'adminActions': 'admin_actions',
      },
      'auditable': {
        'auditableModels': 'Auditable models',
        'ticketingSystemTicket': 'TicketingSystemTicket',
        'providerTicket': 'ProviderTicket',
        'providerComment': 'ProviderComment',
        'providerAttachment': 'ProviderAttachment',
        'subscription': 'Subscription',
        'userFilter': 'UserFilter',
        'provider': 'TicketProvider',
        'partner': 'Partner',
        'ts': 'TicketingSystem',
        'tsColumn': 'BaseColumn',
        'tsQuery': 'TicketingSystemQuery',
        'statusCollection': 'StatusCollection',
        'partnerStatus': 'PartnerStatus',
        'externalStatus': 'ExternalStatus',
        'providerCredential': 'ProviderCredential',
        'attachmentMimeType': 'AttachmentMimeType',
        'mimeTypeCollection': 'MimeTypeCollection',
        'providerTicketBoard': 'ProviderTicketBoard',
      },
    },
    'metaDataPages': {
      'adminSubscriptions': {
        'header': 'Subscriptions',
        'filterBy': 'Filter by',
        'filterPartnerLabel': 'All Partners',
        'filterStatusesLabel': 'All Statuses',
        'table': {
          'ticket': 'Ticket ID',
          'subscribed': 'Subscribed by',
          'userPartner': 'Partner',
          'ticketStatus': 'Ticket Status',
          'title': 'Title',
          'ticketUpdated': 'Ticket Updated',
          'subscriptionCreatedAt': 'Created At',
          'userInfoTooltip': 'Name: {{subscriberName}}\nLogin: {{subscriberLogin}}\nEmail: {{subscriberEmail}}',
        },
      },
      'userFiltersPage': {
        'header': 'User Filters',
        'filterTypesPlaceholder': 'All Types',
        'filterProviderLabel': 'All Providers',
        'showFilter': 'Show Filters',
        'filterPlaceholder': 'Filter name or user',
        'table': {
          'name': 'Name',
          'createdBy': 'Created by',
          'query': 'Query',
          'type': 'Type',
          'partner': 'Partner',
          'ts': 'Ticketing System',
          'provider': 'Ticket Provider',
          'providerTicketBoard': 'Provider Ticket Board',
          'createdAt': 'Created At',
          'userInfoTooltip': 'Name: {{userName}}\nLogin: {{userLogin}}\nEmail: {{userEmail}}',
        },
        'filtersFound': '{{filtersCount}} filters found by:',
      },
      'usersPage': {
        'header': 'Users',
        'table': {
          'login': 'Login',
          'firstName': 'First Name',
          'lastName': 'Last Name',
          'email': 'Email',
          'capability': 'Сapability',
          'partner': 'Partner',
          'lastLogin': 'Last login',
          'alertHeader': 'Remove User',
          'alertText': 'Are you sure you want to remove \'{{ userName }}\' user?',
        },
        'roles': {
          'admin': 'Admin',
          'adminImpersonated': 'Admin Impersonated',
          'adminReadOnly': 'Admin Read Only',
          'adminReadOnlyImpersonated': 'Admin Read Only Impersonated',
          'powerUser': 'Power User',
          'powerUserImpersonated': 'Power User Impersonated',
          'partner': 'Partner',
        },
        'filterPanelTitle': 'Filters',
        'filterPanelTitleTooltip': 'Click to open Filters sidebar',
        'clearAllFiltersTooltip': 'Clear Filters',
        'filterPanelFiltersTooltip': 'Active Filters',
        'usersCount_one': '{{count}} user',
        'usersCount_other': '{{count}} users',
        'clearFilterTooltip': 'Clear "{{filterName}}" Filter',
        'rightSideBar': {
          'header': 'User Details',
          'sectionId': 'Id',
          'sectionFirstName': 'First Name',
          'sectionLastName': 'Last Name',
          'sectionEmail': 'Email',
          'sectionPartner': 'Partner',
          'sectionRole': 'Role',
          'sectionCapability': 'Capability',
          'sectionTimezone': 'Time Zone',
          'sectionLastVisitApiDoc': 'Last Visit of API Doc',
          'sectionFirstLogin': 'First Login',
          'sectionApiDocVisitCount': 'API Doc Visit Count',
          'sectionLoginCount': 'Login Count',
          'autosubscription': 'Autosubscription',
        },
        'filters': {
          'partnerName': 'Partner',
          'login': 'Login',
          'email': 'Email',
          'role': 'Role',
          'capability': 'Сapability',
          'timeZone': 'Time Zone',
          'autosubscription': 'Autosubscription',
          'firstLoginStartDate': 'First Login Start Time',
          'firstLoginEndDate': 'First Login End Time',
          'lastLoginStartDate': 'Last Login Start Time',
          'lastLoginEndDate': 'Last Login End Time',
          'visitApiStartDate': 'Last Visit of API Doc Start Time',
          'visitApiEndDate': 'Last Visit of API Doc End Time',
        },
      },
    },
    'partnerTicketingSystemsPage': {
      'pageHeader': 'Manage Ticketing Systems for {{partnerName}}',
      'addTs': 'Add Ticketing System',
      'addTsNew': 'Add New Ticketing System',
      'importTs': 'Import Ticketing System',
      'formFieldName': 'Name',
      'tsNamePlaceholder': 'Please enter Ticketing System name',
      'table': {
        'displayId': 'Display ID',
        'removeTitle': 'Remove Ticketing System',
        'removeText': 'Are you sure you want to remove \'{{ticketingSystemName}}\' ticketing system?',
        'name': 'Name',
        'tp': 'Ticket Provider',
        'uiAccess': 'ui access',
        'apiAccess': 'api access',
        'allowNewTickets': 'create tickets ',
        'attachments': 'attachments',
        'comments': 'comments',
        'manageColumns': 'Manage Columns',
      },
      'rightSideBar': {
        'displayId': 'Display ID',
        'tsName': 'Ticketing System Name',
        'tp': 'Ticket Provider',
        'tpLinkTooltip': 'Open Ticket Provider',
        'statusCollection': 'Status Collection',
        'statusCollectionLinkTooltip': 'Open Status Collection',
        'uiAccess': 'UI Access',
        'apiAccess': 'API Access',
        'allowNewTickets': 'Create tickets',
        'attachments': 'Attachments',
        'comments': 'Comments',
        'emailSettings': 'Email Settings',
        'emailSettingsComment': 'Display Comment Details',
        'emailSettingsAttachment': 'Display Attachment Details',
        'publishInternalFields': 'Publish Internal Fields',
        'usePtgwTimestamp': 'Use internal Relay timestamp for ticket filtering by default',
        'ticketBonding': 'Ticket Bonding',
        'manageUiAccess': 'UI Access management',
        'addUiAccess': 'Add Role',
        'editUiAccess': 'Edit Role',
        'uiAccessIsEmpty': 'UI Access not configured',
        'uiAccessRole': 'role',
        'uiAccessRolePlaceholder': 'Please, enter user role',
        'uiAccessAccessPlaceholder': 'Please, select UI Access',
        'uiAccessAccess': 'Ui access',
        'uiAccessRemoveTitle': 'Remove Role',
        'uiAccessRemoveAlert': 'Are you sure you want to remove \'{{ roleName }}\' Role?',
        'excludedPartnerStatuses': 'Excluded Partner Statuses',
        'excludedPartnerStatusesTooltip': 'Unbonded tickets with selected partners statuses will be not displayed',
      },
      'settingsModal': {
        'title': 'Ticketing System Settings',
      },
    },
    'feedbackPage': {
      'pageHeader': 'Feedback',
      'feedbacksFound': '{{feedbacksCount}} feedback found by:',
      'filter': {
        'statusFilterPlaceholder': 'All Statuses',
        'partnerFilterPlaceholder': 'All Partners',
        'searchPlaceholder': 'search feedback...',
      },
      'table': {
        'status': 'status',
        'reference': 'reference',
      },
      'sidebar': {
        'experience': 'experience',
        'reference': 'reference',
        'status': 'status',
        'statusRejected': 'Rejected',
        'statusApproved': 'Approved',
        'notes': 'Notes',
        'originLocation': 'origin location',
      },
    },
    'feedbackSidebarForm': {
      'title': 'Send us your feedback!',
      'subtitle1': 'Do you have a suggestion or have found an issue?',
      'subtitle2': 'Let the Relay team know.',
      'experienceSectionTitle': 'How was your experience?',
      'descSectionTitle': 'Describe your experience',
      'buttonLabel': 'Send Feedback',
      'menuButtonTooltip': 'Send Feedback',
    },
    'signInPanel': {
      'title': 'Your Auth Provider',
      'signIn': 'Sign In',
    },
    'sandboxSignInPanel': {
      'name': 'Input Your Name',
      'provider': 'Select Provider',
      'role': 'Select Role',
    },
    'ticketsSearchResultsPage': {
      'pageHeader': 'Search Results',
      'moreLink': 'Show More',
      'ticketsFound': '{{ticketsCount}} tickets found',
    },
    'ticketProviderTicketsSearchResultsPage': {
      'pageHeader': 'Search Results',
      'moreLink': 'Show More',
      'ticketsFound': '{{ticketsCount}} tickets found',
    },
    'welcomePage': {
      'greeting': 'Welcome',
      'selectTS': 'Select a Ticketing System....',
    },
    'ticketTableEditPage': {
      'pageHeader': 'Edit Ticket Table',
      'addColumns': 'Add Column(s)',
      'editColumnList': 'Edit Column List',
      'addNewColumns': 'Add New Column(s)',
      'columns': 'Column(s)',
      'columnName': 'Column Name',
      'tooltipRemoveColumn': 'Remove Column',
    },
    'ticketProviderTicketPage': {
      'tableNoData': 'no data',
      'deleteTicketLink': 'Remove ticket',
      'reloadTicketLink': 'Reload ticket',
      'requestTicketLink': 'Show ticket requests',
      'removeTicketTitle': 'Remove Ticket',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}}',
      'commentsAll': 'All',
      'commentsOnly': 'only',
      'comments': 'Comments',
      'commentsNo': 'No comments',
      'attachments': 'Attachments',
      'attachmentsNo': 'No attachments',
      'attachmentsHeaderId': 'ID',
      'attachmentsHeaderFilename': 'Filename',
      'attachmentsHeaderOwner': 'Owner',
      'attachmentsHeaderCreated': 'Created',
      'attachmentsHeaderSize': 'Size',
      'sidebarDetails': 'DETAILS',
      'sidebarSectionTicketProvider': 'TICKET PROVIDER',
      'sidebarSectionRelayId': 'Relay Ticket ID',
      'sidebarSectionType': 'Type',
      'sidebarSectionChildren': {
        'title': 'Children',
        'columns': {
          'id': 'Ticket ID',
          'title': 'Title',
        },
      },
      'filteredBy': 'Filtered By',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners',
        'extensionsFilterPlaceholder': 'All Types',
        'searchPlaceholder': 'search attachments',
        'filterPanelSearchTooltip': 'Click to Search',
        'filterPanelClearSortingTooltip': 'Clear Sorting',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE',
          'type': 'TYPE',
          'size': 'SIZE',
          'filename': 'FILE NAME',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners',
        'authorsFilterPlaceholder': 'All Authors',
        'searchPlaceholder': 'search comments',
        'filterPanelSearchTooltip': 'Click to Search',
        'filterPanelClearSortingTooltip': 'Clear Sorting',
        'sortFieldLabel': 'CREATED DATE',
      },
      'childrenSection': {
        'title': 'Children',
      },
    },
    'ticketProviderTicketsPage': {
      'removeTicketsTitle': 'Remove Tickets',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}}',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}}',
      'statusesFilterPlaceholder': 'All Statuses',
      'searchPlaceholder': 'Search {{ticketProviderName}} tickets...',
      'searchPlaceholderNew': 'search tickets',
      'bulkRemoveLink': 'Bulk remove',
      'removeTicketsLink': 'Remove selected tickets',
      'reloadTicketsLink': 'Reload tickets',
      'ticketsFound': '{{ticketsCount}} tickets found by:',
      'ticketsCount_one': '{{count}} ticket',
      'ticketsCount_other': '{{count}} tickets',
      'sortedByPlaceholder': 'Choose Sorting Field',
      'resetSortingTooltip': 'Reset to Default',
      'sortDirectionTooltip': 'Reverse Sort Direction',
      'sortRelayTicketIdLabel': 'Relay Ticket Id',
      'clearFiltersLink': 'Clear All Filters',
      'tableHeaderId': 'Ticket ID',
      'tableHeaderPartnerId': 'Partner ID',
      'tableHeaderOwner': 'Owner',
      'tableHeaderStatus': 'Status',
      'tableHeaderTitle': 'Title',
      'tooltipMultiUserFilter': 'Multi-user filter',
      'tooltipAdminOnlyFilter': 'Admin-only filter',
      'tooltipPrivateFilter': 'Private filter',
      'filters': 'Filters',
      'removeFilterTitle': 'Remove Filter',
      'removeFilterMessage': 'Are you sure you want to remove \'{{ filterName }}\'  filter?',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children',
      'tooltipChildTicketsMore': ' and {{count}} more',
      'attachmentsCount_one': '{{count}} attachment',
      'attachmentsCount_other': '{{count}} attachments',
      'commentsCount_one': '{{count}} comment',
      'commentsCount_other': '{{count}} comments',
      'emptyFiltersText': 'No active filters available',
      'createFilterTooltip': 'Create Filter',
      'editFilterTooltip': 'Edit Filter',
      'removeFilterTooltip': 'Remove Filter',
      'filterPanelTitle': 'Tickets View',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar',
      'filterPanelFiltersTooltip': 'Active Custom Filters',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters',
      'filterPanelSearchTooltip': 'Click to Search',
      'filterPanelClearSortingTooltip': 'Clear Sorting',
      'filtersStatusSectionTitle': 'Statuses',
      'filterForm': {
        'title': 'Filter Settings',
        'generalInformation': 'General Information',
        'conditions': 'Conditions',
        'saveFilter': 'Save Filter',
        'deleteFilter': 'Delete Filter',
        'fieldLabelName': 'Name',
        'fieldLabelVisibility': 'Visibility',
        'visibilityPrivate': 'Private',
        'visibilityAdmins': 'Admins',
        'visibilityAllUsers': 'All Users',
        'advancedMode': 'Advanced mode',
        'addNewCondition': 'Add New Condition',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3',
        'resultExpression': 'Result Expression',
        'resultExpressionText': 'Show when {{- query}}',
        'table': {
          'field': 'field',
          'operator': 'operator',
          'value': 'value',
        },
        'allFieldsLabel': 'Ticket Fields',
        'dynamicFieldsLabel': 'Dynamic Options',
        'selectFieldPlaceholder': 'select field',
        'selectOperatorPlaceholder': 'select operator',
        'selectValuePlaceholder': 'select value',
        'optionLabels': {
          'is_me': 'Is Me',
          'my_company': 'My Company',
        },
        'removeConditionTooltip': 'Remove Condition',
      },
    },
    'ticketProvidersListPage': {
      'greeting': 'Welcome',
      'selectTicketProvider': 'Select a Ticket Provider...',
    },
    'scrollableTabsPanel': {
      'noTicketingSystems': 'There is no Ticketing Systems by this Provider',
      'provider': 'Provider',
    },
    'partnerOauthAppsPage': {
      'pageHeader': 'Manage Oauth Applications',
      'newApplication': 'New Application',
      'removeAppTitle': 'Remove Oauth Application',
      'removeAppMessage': 'Are you sure you want to remove \'{{ oauthAppName }}\' Oauth Application?',
      'addNewApp': 'Add New Application',
      'nameLabel': 'name',
      'expiresIn': 'Token Expires In',
      'expiresInTooltip': 'Token TTL in seconds',
      'secretModal': {
        'title': '{{name}} Secret',
        'notification': 'The Secret is only visible once here. You can copy it for further use.',
        'copyButton': 'Copy Secret',
        'secret': 'secret',
        'copiedTooltip': 'Secret copied to clipboard',
      },
      'table': {
        'name': 'Name',
        'createdAt': 'Created At',
      },
    },
    'mimeTypeCollectionsPage': {
      'pageHeader': 'Mime Type Collections',
      'addEntity': 'Add Mime Type Collection',
      'tableHeaderName': 'Mime Type Collection Name',
      'manageMimeTypes': 'Manage Mime Types',
      'formFieldName': 'Name',
      'namePlaceholder': 'Please enter Mime Type Collection name',
      'rightSideBar': {
        'title': 'DETAILS',
        'sectionUsedBy': 'Used By',
        'sectionUsedByTicketProvider': 'Ticket Providers',
      },
      'settingsModal': {
        'title': 'Mime Type Collection Settings',
      },
      'removeEntity': 'Remove Mime Type Collection',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeTypeCollectionName }}\' mime type collection?',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers',
    },
    'mimeTypeCollectionPage': {
      'importMimeTypeCollection': 'Import Mime Type Collection',
      'pageHeader': 'Mime Type Collection',
      'addEntity': 'Add Mime Type',
      'tableHeaderName': 'Mime Type Name',
      'formFieldName': 'Name',
      'namePlaceholder': 'Please enter Mime Type name',
      'rightSideBar': {
        'title': 'DETAILS',
      },
      'settingsModal': {
        'title': 'Mime Type Settings',
      },
      'removeEntity': 'Remove Mime Type',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeType }}\' mime type?',
    },
    'webhookEventsPage': {
      'header': 'Webhook Events',
      'webhookEventsCount_one': '{{count}} webhook event',
      'webhookEventsCount_other': '{{count}} webhooks events',
      'executeWebhookTooltip': 'Execute Webhook Event',
      'markAsIgnoredTooltip': 'Mark as ignored',
      'redirectToRequestsTooltip': 'Requests for Webhook',
      'retryEventsLink': 'Retry failed events',
      'retryFailedEventsValue': 'Retry failed webhook events',
      'retryFailedEventsValueText': 'Please confirm that you want to retry {{count}} failed events for the following tickets: {{numbers}}',
      'filterPanelTitle': 'Filters',
      'filterPanelTitleTooltip': 'Click to open Filters sidebar',
      'filterPanelFiltersTooltip': 'Active Filters',
      'clearAllFiltersTootltip': 'Clear Filters',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter',
      'filters': {
        'ticketNumber': 'Ticket ID',
        'action': 'Action',
        'state': 'State',
        'correlationId': 'Correlation ID',
        'externalEventId': 'External Event ID',
        'webhookId': 'Webhook ID',
        'entitySysId': 'Entity Sys ID',
        'webhookParams': 'Webhook Params',
        'executedStartDate': 'Last Executed At Start Date',
        'executedEndDate': 'Last Executed At End Date',
        'allStates': 'all states',
        'allActions': 'all actions',
        'statePending': 'pending',
        'stateProcessing': 'processing',
        'stateSuccessful': 'successful',
        'stateFailed': 'failed',
        'stateInRetry': 'in retry',
        'stateDuplicate': 'duplicate',
        'stateIgnored': 'ignored',
        'actionTypeUnknown': 'unknown',
        'actionTypeCreateTicket': 'create ticket',
        'actionTypeUpdateTicket': 'update ticket',
        'actionTypeCreateComment': 'create comment',
        'actionTypeCreateAttachment': 'create attachment',
      },
      'search': {
        'placeholder': 'Type ticket number',
      },
      'table': {
        'headerId': 'Id',
        'headerTicketId': 'Ticket Id',
        'headerActionType': 'Action',
        'headerState': 'State',
        'headerCtn': 'Ctn',
        'headerCreatedAt': 'Created At',
        'headerLastExecutedAt': 'Last executed at',
        'headerRequestCount': 'Request Count',
      },
      'rightSideBar': {
        'header': 'Webhook Event Details',
        'sectionId': 'Id',
        'sectionState': 'State',
        'sectionTicketId': 'Ticket Id',
        'sectionParams': 'Webhook Params',
        'sectionCreatedAt': 'Created At',
        'sectionLastExecutedAt': 'Last executed at',
        'sectionRequestCount': 'Request Count',
        'externalEventId': 'External Event Id',
        'sectionCtn': 'Ctn',
        'entitySysId': 'Entity sys Id',
        'correlationID': 'Correlation Id',
        'lastResponsePayload': 'last Response Payload',
        'errorMessage': 'Error Message',
      },
    },
    'satCompliance': {
      'compliant': 'Compliant',
      'soonOutOfCompliance': 'Soon Out of Compliance',
      'outOfCompliance': 'Out of Compliance',
      'notUsed': 'Not Used',
      'disabled': 'Disabled',
    },
    'satClientsPage': {
      'pageHeader': 'SAT Clients',
      'syncClients': 'Sync SAT Clients',
      'clientsCount': '{{count}} SAT Clients',
      'filterPanelTitle': 'Filters',
      'filterPanelTitleTooltip': 'Click to open Filters sidebar',
      'filterPanelFiltersTooltip': 'Active Filters',
      'clearAllFiltersTooltip': 'Clear Filters',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter',
      'filters': {
        'clientId': 'SAT Client ID',
        'capabilities': 'Capabilities',
        'partner': 'Partner',
        'enabled': 'Enabled',
        'approved': 'Approved',
        'compliance': 'Compliance',
        'expiresAtStartDate': 'Expires At Start Time',
        'expiresAtEndDate': 'Expires At End Time',
        'lastUsedAtStartDate': 'Last Used At Start Time',
        'lastUsedAtEndDate': 'Last Used At End Time',
      },
      'table': {
        'id': 'ID',
        'clientID': 'Client ID',
        'partner': 'Partner',
        'enabled': 'Enabled',
        'approved': 'Approved',
        'capabilities': 'Capabilities',
        'compliance': 'Compliance',
        'openSatSecretsTooltip': 'Manage SAT Secrets',
        'openManagersModalTooltip': 'Open Managers',
      },
      'rightSideBar': {
        'header': 'SAT Client Details',
        'sectionClientId': 'Client ID',
        'sectionCompliance': 'Compliance',
        'sectionPartner': 'Partner',
        'sectionDescription': 'Description',
        'sectionCapabilities': 'Capabilities',
        'sectionEnabled': 'Enabled',
        'sectionApproved': 'Approved',
        'sectionManagers': 'Managers',
        'sectionCreatedAt': 'Created At',
        'sectionUpdatedAt': 'Updated At',
        'sectionSecrets': 'Secrets',
        'secretsColumns': {
          'lastFour': 'Last Four',
          'active': 'Active',
          'expiresAt': 'Expires At',
          'compliance': 'Compliance',
        },
      },
      'managersModal': {
        'title': 'Set Managers',
        'label': 'Manager List',
        'placeholder': 'Enter user login or email',
      },
    },
    'satSecretsPage': {
      'pageHeader': 'SAT Secrets',
      'addSecret': 'Add New Secret',
      'addConfirmDialogTitle': 'Confirm',
      'addConfirmDialogMsg': 'Are you sure you want to generate a new secret? This will take effect immediately!',
      'table': {
        'lastFour': 'Last Four',
        'active': 'Active',
        'compliance': 'Compliance',
        'expiresAt': 'Expires At',
        'lastUsedAt': 'Last Used At',
        'disableSecretTooltip': 'Mark as disabled',
        'disableConfirmDialogTitle': 'Confirm Disabling of Client Secret',
        'disableConfirmDialogMsg': 'Are you sure you want to disable the secret?',
      },
      'secretModal': {
        'title': 'New Secret Generated',
        'notification': 'The Secret is only visible once here. You can copy it for further use.',
        'copyButton': 'Copy Secret',
        'copiedTooltip': 'Secret copied to clipboard',
      },
    },
    'providerCredentialsPage': {
      'pageHeader': 'Provider Credentials',
      'addEntity': 'Add Provider Credential',
      'tableHeader': {
        'name': 'Name',
        'credentialType': 'Credential Type',
        'autorotation': 'Autorotate Secrets',
        'nextRotationDate': 'Next Rotation Date',
      },
      'formFieldName': 'Name',
      'namePlaceholder': 'Please enter Provider Credential name',
      'formFieldCredentialType': 'Credential Type',
      'credentialTypePlaceholder': 'Please select Credential Type',
      'rightSideBar': {
        'title': 'DETAILS',
        'sectionUsedBy': 'Used By',
        'sectionUsedByTicketProvider': 'Ticket Providers',
      },
      'settingsModal': {
        'title': 'Provider Credential Settings',
      },
      'removeEntity': 'Remove Provider Credential',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- providerCredentialName }}\' Provider Credential?',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers',
    },
    'confirmDialog': {
      'justificationLabel': 'Justification:',
      'justificationPlaceholder': 'Enter justification here',
    },
  },
}

export default en
